





















import CompanyDetail from './components/CompanyDetail.vue';
import ContactPersonList from './components/ContactPersonList.vue';
import AuthorityList from './components/AuthorityList.vue';
import BusinessAccountList from './components/BusinessAccountList.vue';
import SubcompanyList from './components/SubcompanyList.vue';
import { getAgentDatasApi } from '@/api/company';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'setting',
  components: {
    CompanyDetail,
    ContactPersonList,
    AuthorityList,
    BusinessAccountList,
    SubcompanyList
  }
})
export default class extends Vue {

  public activeName: string = 'ContactPersonList';
  public showSubAgent: boolean = false;

  public mounted() {
    this.getAgentDatas();
  }

  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      const ref = vm.$refs.contactRef;
      ref.getTables();
      vm.getAgentDatas();
    });
  }

  public async getAgentDatas() {
    const { data } = await getAgentDatasApi();
    this.showSubAgent = data.datas.length > 0;
  }

  public handleTabClick(tab: any) {
    this.activeName = tab.name;
    let ref: any = null;
    if (tab.name === 'ContactPersonList') {
      ref = this.$refs.contactRef;
    } else if (tab.name === 'AuthorityList') {
      ref = this.$refs.authorityRef;
    } else if (tab.name === 'BusinessAccountList') {
      ref = this.$refs.businessRef;
    } else {
      ref = this.$refs.subcompanyRef;
    }
    if (ref) {
      this.$nextTick(() => {
        ref.getTables();
      });
    }
  }

}
